
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diferenciais",
      function () {
        return require("private-next-pages/diferenciais/index.js");
      }
    ]);
  